import LearningPageHeroController from "./controllers/learning-page-hero-controller"
import VueI18n from "vue-i18n"
import globals from "@/utils/globals"
import store from "@/store/"

export default (Vue, { locale, id, i18nKey }) => {
  const props = (globals[id] && globals[id].props) || {}

  return new Vue({
    name: "LearningPageHeroInit",
    store,
    i18n: new VueI18n({ locale }),
    render: (h) =>
      h(LearningPageHeroController, {
        props: {
          ...props,
          id,
          i18nKey: i18nKey || props.i18nKey
        }
      })
  })
}
